import { gql } from "@apollo/client";

// One person's place on the ladder, and the criteria written for them alone.
export default gql`
  query getPersonCareer($organizationId: Int!, $userId: Int!) {
    user(userId: $userId) {
      id
      name
      avatar
      currentRoles {
        id
        title
        level
        careerTrack {
          id
          title
        }
      }
    }
    userCareerCriteria(organizationId: $organizationId, userId: $userId) {
      id
      content
      ordinal
    }
  }
`;
